var isObject = require('./_is-object')
  , isArray  = require('./_is-array')
  , SPECIES  = require('./_wks')('species');

module.exports = function(original){
  var C;
  if(isArray(original)){
    C = original.constructor;
    // cross-realm fallback
    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
    if(isObject(C)){
      C = C[SPECIES];
      if(C === null)C = undefined;
    }
  } return C === undefined ? Array : C;
};


//////////////////
// WEBPACK FOOTER
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/~/core-js/modules/_array-species-constructor.js
// module id = ../../../../core-js/modules/_array-species-constructor.js
// module chunks = 9